import ScrollToElement from '~utilities/scroll-to-element';

class ScrollToLink {
    constructor(element, attribute) {
        this.element = element;

	    this.element.addEventListener('click', (event) => {
            event.preventDefault();
            const id = event.target.hash;
            const offset = this.element.getAttribute(attribute);
            const linkTo = document.querySelector(`${id}`);
            new ScrollToElement(linkTo, offset, id);
        })
    }
}

export default ScrollToLink;